






import Vue from 'vue';

export default Vue.extend({
  methods: {
    onClickModalBackground(e: Event) {
      if (e.target === this.$refs.modal) {
        this.$emit('closeModal');
      }
      e.stopPropagation();
    },
  },
});
